<div class="autoDetailHowTo__cont">
  <app-ds-accordion
    [type]="accordionType"
    [size]="accordionSize"
    [text]="assetTermRent?.Header">
    <div class="autoDetailHowTo__body" content>
      <div class="autoDetailHowTo__body-content">
        <ng-container *ngIf="!!assetTermRent">
          <article *ngFor="let item of assetTermRent.Body; last as isLast">
            <ng-container *ngIf="!!item.Title">
              <app-ds-typography
                [size]="fontSize.XXS"
                [color]="fontColor.Primary"
                [fontFamily]="fontFamily.SemiBold"
                [text]="item.Title">
              </app-ds-typography>
            </ng-container>
            <ng-container *ngFor="let paragraphs of item.Paragraphs">
              <app-ds-typography
                [size]="fontSize.XXXS"
                [color]="fontColor.Secondary"
                [fontFamily]="fontFamily.Regular"
                [text]="paragraphs">
              </app-ds-typography>
            </ng-container>
            <div class="autoDetailHowTo__divider" *ngIf="!isLast">
              <app-ds-divider></app-ds-divider>
            </div>
          </article>
        </ng-container>
      </div>
    </div>
  </app-ds-accordion>
</div>
